import styled, { css } from 'styled-components';
import is from 'styled-is';
import { gridSizes, media, zIndexses } from 'utils/style';

import Select from 'components/CustomSelect/component';

const modify = (str) => `&__${str}&__${str}`;

const selectModifierClass = css`
  ${modify('placeholder')} {
    color: var(--grey500);
    margin: 0;
  }

  ${modify('single-value')} {
    margin: 0;
  }
  ${is('hasLabel')`
    ${modify('single-value')} {
      top: 26px;
    }
  `}

  ${modify('control:hover')} {
    border-color: var(--primary500);
  }

  &.warning {
    border-color: var(--primary500);
    box-shadow: inset 0 0 0 1px var(--primary500);
  }

  ${modify('single-value')} {
    color: var(--grey900);
  }

  ${modify('label')} {
    position: absolute;
    display: none;
    top: -2px;
    font-size: 14px;
    line-height: ${gridSizes('M')};
    color: var(--grey700);
  }

  ${modify('placeholder')} {
    color: var(--grey700);
  }

  ${modify('input')} {
    margin: 0;
    padding: 0;
  }

  ${is('hasLabel')`
    ${`${modify('value-container--has-value')} ${modify('input')}`} {
      top: 26px;
    }
  `};

  ${`${modify('value-container--has-value')} ${modify('label')}`} {
    display: block;
  }

  ${modify('menu')} {
    margin: 4px 0;
    width: 125%;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    border: solid 1px var(--grey-mouse);
    z-index: ${zIndexses.customSelect};
    ${media.lessThan('small')`
      width: 100%;
    `}
  }

  ${modify('option')} {
    &:active {
      background-color: var(--grey-mouse);
    }
  }

  ${modify('option--is-focused')} {
    background-color: var(--primary100);
    color: var(--grey900);
  }

  ${modify('option--is-selected')} {
    background-color: var(--primary100);
    color: var(--grey900);
  }
`;

const defaults = css`
  ${modify('control--is-focused')} {
    border-color: var(--primary500);
    box-shadow: inset 0 0 0 1px var(--primary500);
  }
  ${modify('value-container')} {
    padding: 0 12px;
    min-height: calc(${gridSizes('M')} + ${gridSizes('M')});
    overflow: visible;
  }
  ${modify('control')} {
    border-color: var(--grey500);
    border-radius: 0;
    min-height: 48px;
  }
`;

const noBorder = css`
  ${modify('control--is-focused')} {
    border-color: transparent;
    box-shadow: inset 0 0 0 1px transparent;
  }
  ${modify('value-container')} {
    justify-content: flex-end;
    display: flex;
    padding-right: 0;
    overflow: visible;
  }
  ${modify('control')} {
    border-color: transparent;
    box-shadow: inset 0 0 0 1px transparent;
    border-radius: 0;
  }

  ${modify('control:hover')} {
    border-color: var(--transparent);
    cursor: pointer;
  }

  ${modify('indicator')} {
    padding: 0;
  }

  ${modify('placeholder')} {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }
`;

export default styled(Select).attrs((props) => ({
  hasLabel: props.label,
  noBorder: props.noBorder,
  theme: props.theme,
}))`
  ${selectModifierClass};
  ${(props) => (props.noBorder ? noBorder : defaults)};
`;
export { selectModifierClass };
